<template>
  <div>
    <b-card no-header>
      <form>
        <b-form-group
          label="Importe Total"
          label-for="importeTotal"
          description="Importe total neto a certificar"
          :label-cols="2"
          horizontal>
          <b-form-input 
            id="importeTotal"
            v-model.trim="$v.importeTotal.$model" 
            :state="importeTotalValido"
            type="text">
          </b-form-input>
          <b-form-invalid-feedback id="importeTotalFeedback">
            {{ importeTotalInvalidoMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>
      </form>
      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="setImporteTotal">Actualizar</b-button>
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="close">Cancelar</b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import { required, decimal } from 'vuelidate/lib/validators';

export default {
  name: 'CertificadoServicioImporteTotal',
  data: () => {
    return {
      importeTotal: '',
      importeTotalValido: null,
      importeTotalInvalidoMsj: '',
    }
  },
  created() {
  },  
  methods: {
    setImporteTotal() {
      this.$v.$touch();

      if (this.$v.importeTotal.$error) {
        this.importeTotalValido = false;
        if (!this.$v.importeTotal.required) {
          this.importeTotalInvalidoMsj = 'Debe ingresar el importe total a certificar.';
        } else if (!this.$v.importeTotal.decimal) {
          this.importeTotalInvalidoMsj = 'El importe total ingresado no es válido.';
        }      
      } else {
        this.importeTotalValido = null;
        this.importeTotalInvalidoMsj = '';
      }

      if (!this.$v.$anyError) {
        this.$emit('close', this.importeTotal)
      }
    },
    close() {
      this.$emit('close', 0);
    }
  },
  validations: {
    importeTotal: {
      required,
      decimal
    },
  },  
  watch: {
  }    
}
</script>

<style>
</style>
